var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7299_5026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42675 13.1263C3.29276 13.1263 2.28406 12.4002 1.91778 11.3192L1.89301 11.2378C1.80663 10.9515 1.77044 10.7108 1.77044 10.4699V5.64032L0.0520046 11.3766C-0.169009 12.2203 0.334627 13.095 1.17964 13.3281L12.1329 16.2614C12.2696 16.2968 12.4063 16.3138 12.541 16.3138C13.2464 16.3138 13.891 15.8456 14.0717 15.1556L14.7099 13.1263H4.42675Z",
    fill: "url(#paint0_linear_7299_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37573 5.68853C7.15706 5.68853 7.79234 5.05312 7.79234 4.27179C7.79234 3.49046 7.15706 2.85504 6.37573 2.85504C5.5944 2.85504 4.95898 3.49046 4.95898 4.27179C4.95898 5.05312 5.5944 5.68853 6.37573 5.68853Z",
    fill: "url(#paint1_linear_7299_5026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2281 0.730042H4.60286C3.62685 0.730042 2.83203 1.52486 2.83203 2.501V10.2928C2.83203 11.2689 3.62685 12.0637 4.60286 12.0637H15.2281C16.2043 12.0637 16.9991 11.2689 16.9991 10.2928V2.501C16.9991 1.52486 16.2043 0.730042 15.2281 0.730042ZM4.60286 2.14679H15.2281C15.4237 2.14679 15.5823 2.30541 15.5823 2.501V7.52959L13.3447 4.91854C13.1074 4.64019 12.7638 4.49143 12.3948 4.48299C12.0278 4.48507 11.6836 4.64798 11.4485 4.92995L8.81756 8.0877L7.96048 7.2327C7.47604 6.74826 6.68758 6.74826 6.20379 7.2327L4.24878 9.18706V2.501C4.24878 2.30541 4.4074 2.14679 4.60286 2.14679Z",
    fill: "url(#paint2_linear_7299_5026)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7299_5026",
    x1: 7.35493,
    y1: 5.64032,
    x2: 7.35493,
    y2: 16.3138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7299_5026",
    x1: 6.37566,
    y1: 2.85504,
    x2: 6.37566,
    y2: 5.68853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7299_5026",
    x1: 9.91556,
    y1: 0.730042,
    x2: 9.91556,
    y2: 12.0637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7299_5026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPhotoIcon);
export default __webpack_public_path__ + "static/media/view-photo-icon.f558dfbcd0cb4d3f9c5525b304692970.svg";
export { ForwardRef as ReactComponent };